import { Store } from "pullstate";

export const WithdrawStore = new Store({
    withdrawState: {},
    openPreviewModal: false,
    openSuccessModal: false,
    loading: false
});